<template>
  <OmtGrid class="refund-audit-page refund-audit-form-page">
    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      mb="20px"
    >
      <OmtTypography as="h1-bold"> Análise da solicitação </OmtTypography>
    </OmtRow>
    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      mb="12px"
    >
      <CFlex>
        <OmtIcons
          name="square-poll-horizontal"
          mr="12px"
          size="lg"
        />
        <OmtTypography as="h3-semi-bold"> Protocolo: {{ refund.protocol }} </OmtTypography>
      </CFlex>
    </OmtRow>
    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
    >
      <CFlex
        justify-content="space-between"
        w="100%"
      >
        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
        >
          Solicitação de reembolso • {{ refund.totalAmount }}
        </OmtTypography>

        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
        >
          {{ refund.createdAt }}
        </OmtTypography>
      </CFlex>
    </OmtRow>
    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
    >
      <OmtDivider
        mt="24px"
        mb="22px"
      />
    </OmtRow>

    <OmtRow
      v-show="!!auditFormManager.getComponent"
      :desktopStart="2"
      :desktopEnd="11"
      mb="48px"
    >
      <AuditForm
        :is="auditFormManager.getComponent"
        :question="currentAuditQuestion"
        :dueDate="dueDate"
        @change="handleChange"
      />
    </OmtRow>

    <OmtRow
      :desktopStart="5"
      :desktopEnd="8"
    >
      <AuditFormConfirmButtons
        :disabled="value === 0 || value === ''"
        :continueLabel="continueLabel"
        :showCancel="showCancelAction"
        @continue="handleContinue"
        @cancel="showCancellationModal = true"
      />
    </OmtRow>

    <AuditFormCancellationModal
      :isOpen.sync="showCancellationModal"
      @cancel="sendToTermsFromCancel"
    />
  </OmtGrid>
</template>

<script>
import * as AuditForm from "@/components/Organisms/RefundNew/AuditForm";
import AuditFormCancellationModal from "@/components/Organisms/RefundNew/AuditForm/AuditFormCancellationModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    AuditFormCancellationModal,
    ...AuditForm
  },
  data() {
    return {
      auditFormManager: {},
      value: "",
      showCancellationModal: false,
      refund: {},
      ticket: null,
      dueDate: ""
    };
  },
  computed: {
    ...mapState("refund", ["audit"]),
    currentAuditQuestion() {
      const questionId = this.auditFormManager?.current?.id;
      return this.audit[questionId];
    },
    continueLabel() {
      return this.auditFormManager?.getComponent === "AuditFormRealizedAllProcedures" ? "Próximo" : "Continuar";
    },
    showCancelAction() {
      return (this.auditFormManager?.answers?.length || 0) > 1;
    }
  },
  async mounted() {
    await this.$root.$emit("change-title-label", "Auditoria de reembolso");

    if (this.$route.params.dueDate) this.dueDate = this.$route.params.dueDate;
    if (this.$route.params.refund) this.refund = this.$route.params.refund;
    if (this.$route.params.ticket) this.ticket = this.$route.params.ticket;

    if (!this.refund || !this.ticket) {
      this.$router.push({
        path: "/refund-new/list"
      });

      return;
    }

    this.auditFormManager = new AuditForm.AuditFormManager(this.loadQuestion, this.saveQuestionResponse);
  },
  methods: {
    ...mapActions("refund", ["fetchAuditQuestion", "saveAuditResponse"]),
    handleChange($event) {
      this.value = Number.parseInt($event);
      this.auditFormManager.storeAnswer({ value: this.value });
    },
    handleContinue() {
      this.auditFormManager.saveAndGetNext();
      this.value = "";
    },
    sendToTermsFromCancel() {
      this.$router.replace({
        name: "refund.new.audit.term",
        query: this.$route.query,
        params: {
          scenario: 6,
          answers: [],
          refund: this.refund,
          ticket: this.ticket,
          mustCancelProtocol: true
        }
      });
    },
    sendToTerms(dueDate = "") {
      this.$router.replace({
        name: "refund.new.audit.term",
        query: this.$route.query,
        params: {
          scenario: this.auditFormManager.scenarioIndex,
          dueDate,
          answers: this.auditFormManager.answers,
          refund: this.refund,
          ticket: this.ticket
        }
      });
    },
    async loadQuestion(questionTypeId) {
      try {
        await this.$root.$emit("show-loading");

        if (this.ticket && this.refund.protocol) {
          await this.fetchAuditQuestion({
            ticket: this.ticket,
            protocol: this.refund.protocol,
            questionTypeId
          });
        } else {
          this.$router.push({
            path: "/refund-new"
          });
        }
      } catch (error) {
        this.$toast({
          description: error.message,
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    async saveQuestionResponse({ questionTypeId, option }) {
      try {
        await this.$root.$emit("show-loading");
        const { EncerrarFluxo } = await this.saveAuditResponse({
          questionTypeId,
          option
        });

        if (EncerrarFluxo) this.sendToTerms(this.dueDate);
      } catch (error) {
        this.$toast({
          description: error.message,
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>

<style scoped>
.refund-audit-page {
  align-content: start;
}

@media screen and (min-width: 1024px) {
  .refund-audit-page {
    max-width: 1104px;
  }
}
</style>
